import * as React from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/StatusBadge";
import { getMachineTypeLabel } from "@/lib/display-labels";
import type { MachineDetail } from "@/features/lines/hooks";

interface HeaderProps {
  isCreating: boolean;
  machine: MachineDetail | undefined;
  onClose: () => void;
}

export function Header({ isCreating, machine, onClose }: HeaderProps): React.ReactElement {
  return (
    <header className="flex items-start justify-between gap-2 border-b p-4">
      <div className="min-w-0 flex-1">
        {isCreating ? (
          <>
            <p className="text-muted-foreground text-xs uppercase tracking-wide">Nova máquina</p>
            <h2 className="text-base font-semibold">Configure os dados básicos</h2>
          </>
        ) : machine ? (
          <>
            <p className="text-muted-foreground font-mono text-xs">{machine.code}</p>
            <h2 className="truncate text-base font-semibold">{machine.name}</h2>
            <div className="mt-1 flex items-center gap-2">
              <StatusBadge status={machine.status} kind="machine" />
              <span className="text-muted-foreground text-xs">
                {getMachineTypeLabel(machine.type)}
              </span>
            </div>
          </>
        ) : (
          <h2 className="text-muted-foreground text-base font-semibold">Máquina não encontrada</h2>
        )}
      </div>
      <Button variant="ghost" size="icon" aria-label="Fechar" onClick={onClose}>
        <X className="h-4 w-4" />
      </Button>
    </header>
  );
}
